import React, { Component } from 'react';
import {Helmet} from "react-helmet";
import PropTypes from 'prop-types';
import { sharing } from '../data/sharing';

class MetaTags extends Component {

    render() {
        const shareURL = this.props.shareURL || sharing.home.ogUrl;
        const shareTitle = this.props.shareTitle || sharing.home.ogTitle;
        const shareDesc = this.props.shareDesc || sharing.home.ogDesc;
        const shareImage = this.props.shareImage || sharing.home.ogImage;

        return (
            <Helmet>
              {shareTitle && <title>{shareTitle}</title>}
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:site" content="@ttclabs" />
              {shareURL && <meta property="og:url" content={shareURL} />}
              <meta property="og:type" content="website" />
              {shareTitle && <meta property="og:title" content={shareTitle} />}
              {shareDesc && <meta property="og:description" content={shareDesc} />}
              {shareImage && <meta property="og:image" content={shareImage} />}
            </Helmet>
        )
    }
}

MetaTags.propTypes = {
  shareURL: PropTypes.string,
  shareTitle: PropTypes.string,
  shareDesc: PropTypes.string,
  shareImage: PropTypes.string,
};

export default MetaTags;